/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import OverviewCard from "../../components/OverviewCard/OverviewCard";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Kpi from "../../components/KPI/Kpi";
import ProgressBar from "../../components/ProgressBar/ProgressBar";

function OverviewMobile({ app, config }) {
	const [scorePercentageNum, setScorePercentageNum] = useState(0);
	const [scorePercentageColor, setScorePercentageColor] = useState("#38BC9A");

	const { selections } = useSelections();
	const [selectedGroup, setSelectedGroup] = useState("");
	const [singleGroupView, setSingleGroupView] = useState(false);

	const [score, totalScore, scorePercentage] = [
		Kpi({
			app,
			objectId: "kvsLs",
			updatesWithSelection: true,
		}),
		Kpi({
			app,
			objectId: "hhqJDa",
			updatesWithSelection: true,
		}),
		Kpi({
			app,
			objectId: "MFYzdU",
			updatesWithSelection: true,
		}),
	];

	const getColorFromPercentage = (percentage) => {
		switch (true) {
			case percentage < 85:
				return "#E95248";
			case percentage < 100:
				return "#FDB949";
			default:
				return "#38BC9A";
		}
	};

	useEffect(() => {
		if (app) {
			// update title with selected distributor (when only 1 is selected)
			const distributors = selections.length
				? selections.find((s) => s.qField === "Distribuidor")
				: null;
			setSelectedGroup(
				distributors
					? distributors?.qSelectedCount === 1
						? `: ${distributors.qSelected}`
						: ""
					: ""
			);
			setSingleGroupView(distributors?.qSelectedCount === 1);
		}
	}, [app, selections]);
	
	useEffect(() => {
		const num = scorePercentage ? scorePercentage.slice(0, -1) * 1 : 0;
		setScorePercentageNum(num > 100 ? 100 : num);
	}, [scorePercentage]);

	useEffect(() => {
		setScorePercentageColor(getColorFromPercentage(scorePercentageNum));
	}, [scorePercentageNum]);

	return (
		<div className="app overview">
			<div className="appContent">
				<LayoutWrapper>
					<Grid
						container
						flexDirection="column"
						justifyContent="flex-start"
						rowGap={2}
					>
						{/* KPI CARDS CONTAINER */}
						<Grid
							container
							item
							xs
							flexDirection="column"
							justifyContent="flex-start"
							alignItems="stretch"
							rowGap={2}
						>
							{/* AREA ACTING CARD */}
							<Grid item xs>
								<OverviewCard
									app={app}
									cardTitle={"Área de Atuação"}
									doubleKpi={true}
									firstKpiTitle={"Sell out"}
									secondKpiTitle={"Positivação"}
									firstValueId={"LJAzERQ"}
									firstGoalValueId={"pQzpP"}
									firstPercentageId={"PpuupKP"}
									firstScoreId={"uvDDns"}
									firstRedirectUrl={`/area/sell-out`}
									secondValueId={"pAEBp"}
									secondGoalValueId={"RaFeRaf"}
									secondPercentageId={"mjpb"}
									secondScoreId={"DPTZGZW"}
									secondRedirectUrl={`/area/positivacao`}
									singleGroupView={singleGroupView}
								/>
							</Grid>

							{/* GOLDEN STORES CARD */}
							<Grid item xs>
								<OverviewCard
									app={app}
									cardTitle="Golden Stores"
									doubleKpi={true}
									firstKpiTitle={"Sell out"}
									secondKpiTitle={"Distribuição"}
									firstGoalValueId={"JBfmdwS"}
									firstValueId={"gveh"}
									firstPercentageId={"NXNjxAA"}
									firstScoreId={"yHUmq"}
									firstRedirectUrl={`/golden-stores/sell-out`}
									singleGroupView={singleGroupView}
								/>
							</Grid>
						</Grid>

						{/* RANKING GERAL DE PONTOS */}
						<Grid item xs sx={{ height: "100%" }}>
							<Card
								app={app}
								style={{
									height: "100%",
									width: "100%",
								}}
							>
								<Grid
									container
									flexDirection={"column"}
									justifyContent={"space-between"}
									alignItems={"flex-start"}
								>
									<Grid item xs sx={{ height: "100%" }}>
										<ComboHeader
											reference={{
												title: {
													hard: "Ranking Geral de Pontos",
												},
											}}
											legends={[
												{
													type: "bar",
													iconColor:
														"#fdb949",
													name: "Pontos realizados",
												},
												{
													type: "bar",
													iconColor:
														"#ff7f27",
													name: "Pontos possíveis",
												},
											]}
										/>
									</Grid>
									<Grid
										item
										xs
										sx={{
											minHeight: "426px",
											height: "100%",
											width: "100%",
										}}
									>
										<NativeObject
											app={app}
											key="uCRdDB"
											reference={{ id: "uCRdDB" }}
											style={{
												padding: "0 24px ",
											}}
										/>
									</Grid>
								</Grid>
							</Card>
						</Grid>

						{/* EXTRA SCORES CONTAINER */}
						<Grid
							container
							item
							xs
							flexDirection="row"
							justifyContent="flex-start"
							gap={2}
						>
							<Grid item xs>
								<OverviewCard
									app={app}
									cardTitle="Pontuação Extra"
									singleGroupView={singleGroupView}
								/>
							</Grid>
							<Grid item xs>
								<Card
									app={app}
									header={{
										hardTitle: "Pontuação Total",
									}}
									style={{
										height: "100%",
									}}
								>
									{/* SCORE KPI */}
									<Grid
										container
										item
										flexDirection={"row"}
										justifyContent={"flex-start"}
										alignItems={"flex-start"}
										rowGap={1}
									>
										<Grid
											className={`value-wrapper`}
											container
											item
											xs={12}
											flexDirection={"row"}
											justifyContent={"flex-start"}
											alignItems={"center"}
											sx={{
												width: "100%",
											}}
										>
											<Grid
												item
												container
												xs
												flexDirection={"row"}
												justifyContent={"flex-start"}
												alignItems={"center"}
												columnGap={1}
											>
												{/* SCORE */}
												<Box
													component={"span"}
													className="value"
													style={{
														color: scorePercentageColor,
													}}
												>
													{score}
												</Box>
												<Box
													component={"span"}
													className="value"
													style={{
														color: scorePercentageColor,
													}}
												>
													{`pontos realizados`}
												</Box>
											</Grid>
										</Grid>
										{/* PROGRESS BAR */}
										<Grid
											container
											item
											flexDirection={"column"}
											justifyContent={"flex-start"}
											alignItems={"flex-start"}
											style={{
												width: "100%",
											}}
											xs={12}
										>
											<ProgressBar
												key={"Sell out"}
												bgColor={scorePercentageColor}
												completed={scorePercentageNum}
											/>
										</Grid>

										{/* GOAL AND PERCENTAGE */}
										<Grid
											container
											item
											flexDirection={"row"}
											justifyContent={"flex-start"}
											alignItems={"flex-start"}
											xs
											columnGap={1}
										>
											{/* TOTAL SCORE */}
											<Grid
												className={`goal-wrapper`}
												container
												item
												flexDirection={"row"}
												justifyContent={"flex-start"}
												alignItems={"center"}
												columnGap={0.8}
												xs
											>
												<Grid
													item
													container
													xs
													flexDirection={"row"}
													justifyContent={
														"flex-start"
													}
													alignItems={"center"}
													columnGap={1}
												>
													{/* TOTAL SCORE VALUE */}
													<Box
														component={"span"}
														className="goal-value"
													>
														{totalScore}
													</Box>
													{/* TOTAL SCORE TEXT */}
													<Box
														component={"span"}
														className="goal-text"
													>
														pontos possíveis
													</Box>
												</Grid>
											</Grid>

											{/* GOAL PERCENTAGE */}
											<Grid
												className={`percentage-wrapper`}
												container
												item
												flexDirection={"row"}
												justifyContent={"flex-start"}
												alignItems={"center"}
												columnGap={0.8}
												xs={4}
											>
												<Grid item>
													<Box
														component={"span"}
														className="percentage-value"
														style={{
															color: scorePercentageColor,
														}}
													>
														{scorePercentage}
													</Box>
												</Grid>
												<Grid item>
													<Box
														component={"span"}
														className="percentage-text"
													>
														Ating.
													</Box>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Card>
							</Grid>
						</Grid>
					</Grid>
				</LayoutWrapper>
			</div>
		</div>
	);
}

OverviewMobile.defaultProps = {
	app: null,
	config: {},
};

OverviewMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OverviewMobile;
